<template>
    <div v-if="filterInfo!==null">
        <modal-x :show="showQueryMenu" @onclose="setShow(false)" :content-style="{ maxWidth: '800px' }">
            <filter-menu-form @search="onquery" :langOverride="lang" :filterInfo="filterInfo" listingType="listing" :autoRoute="false"></filter-menu-form>
        </modal-x>
    </div>
</template>

<script>
import modalX from '../components/base/ModalX1.vue';
import FilterMenuForm from '../components/FilterMenuForm.vue';

export default {
    components: {
        modalX: modalX,
        FilterMenuForm:FilterMenuForm
    },
    props: ["filterInfo", "listingType", "showQueryMenu"],
    computed: {
        lang: function () {
            return {
                common: { showAll: "show all", categories: "categories", keyword: "keyword", search: "search", tags: "tags" }
            };
        }
    },
    data: function () {
        return {
            
        }
    },
    methods: {
        onquery: function (routeObj) {
            this.$emit("onquery",routeObj);
            this.emitOnClose(); 
        },
        emitOnClose(){
            this.$emit("onclose");
        },
        setShow: function (toShow) {
            this.showMenu = toShow;
            if (this.showMenu === false) {
               this.emitOnClose();
            }
        }
    },
    created: function () {
    }
}
</script>
